export default {
  install(app) {
    const adServer = {
      inited: false,
      spotNumber: 0,
      loadAd(id, dataZone) {
        window._ASO.loadAd(id, dataZone)
      },
      async init() {
        if (!this.inited) {
          await this.loadScript()
          this.inited = true
        }
        this.spotNumber += 1
        return `html-id-${this.spotNumber}`
      },
      loadScript() {
        return new Promise((resolve) => {
          const script = document.createElement('script')
          script.async = true
          script.setAttribute('src', 'https://media.aso1.net/js/code.min.js')
          script.setAttribute('data-cfasync', 'false')
          script.onload = resolve
          document.body.appendChild(script)
        })
      }
    }

    app.config.globalProperties.$adServer = adServer
    app.provide('adServer', adServer)
  }
}
